module.exports = __webpack_public_path__ + "static/media/Anil_pic.af8d1a6d.png";